var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMTorse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 178,
    viewBox: "0 0 125 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70819 20.156C5.70114 38.53 14.0474 84.7968 14.7972 98.0455C15.8229 116.169 9.54522 165.695 7.61611 177.036",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25811 0.0356445C8.25811 0.0356445 6.32474 26.92 18.446 37.7084",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3406 56.0598C8.10314 45.2103 3.99975 35.2937 0.580344 15.4607",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 4.28677,
    strokeLinecap: "square",
    strokeDasharray: "4.02 4.02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.734 20.156C118.741 38.53 110.395 84.7968 109.645 98.0455C108.62 116.169 114.897 165.695 116.827 177.036",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.184 0.0356445C116.184 0.0356445 118.118 26.92 105.996 37.7084",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.102 56.0598C116.339 45.2103 120.443 35.2937 123.862 15.4607",
    stroke: "black",
    strokeWidth: 1.0046,
    strokeMiterlimit: 4.28677,
    strokeLinecap: "square",
    strokeDasharray: "4.02 4.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMTorse2);
export default __webpack_public_path__ + "static/media/M-TORSE_2.b20d5213a9aa81077407ed32249a84dc.svg";
export { ForwardRef as ReactComponent };